const MARKETO_MUNCHKIN_ID = "128-JHR-871";
const MARKETO_FORMS_BASEURL = "//info.productboard.com"; // Marketo LP domain
const MARKETO_XDFRAME_SETTINGS = "/rs/128-JHR-871/images/marketo-xdframe-relative.html"; // Anti Tracking Protection

let inlineForms = [];

const initializeForm = form => {
    const formId = form.getAttribute("data-form-id");
    if (!formId) return;

    form.setAttribute("id", "mktoForm_" + formId)

    MktoForms2.setOptions({
        formXDPath: MARKETO_XDFRAME_SETTINGS
    })

    MktoForms2.loadForm(MARKETO_FORMS_BASEURL, MARKETO_MUNCHKIN_ID, formId)
}

const destyleMktoForm = (mktoForm, moreStyles) => {
    const formEl = mktoForm.getFormElem()[0],
        arrayify = getSelection.call.bind([].slice);
  
    // remove element styles from <form> and children
    const styledEls = arrayify(formEl.querySelectorAll('[style]')).concat(formEl)
    styledEls.forEach(el => {
      el.removeAttribute('style')
    })
  
    // disable remote stylesheets and local <style>s
    const styleSheets = arrayify(document.styleSheets);
    styleSheets.forEach(stylesheet => {
      if (
        [mktoForms2BaseStyle, mktoForms2ThemeStyle].indexOf(stylesheet.ownerNode) != -1 ||
        formEl.contains(stylesheet.ownerNode)
      ) {
        stylesheet.disabled = true
      }
    });
  
  
    // find all stylesheets that contains string "mktoForm" and remove them
    [...document.styleSheets].forEach(item => {
      if (item.ownerNode.innerHTML.includes('mktoForm')) {
        item.ownerNode.remove()
      }
    })
  
    // find all <style>s inside the marketo form and remove them
    const styles = formEl.querySelectorAll('style')
    for (const item of styles) {
      item.remove()
    }
  
    if (!moreStyles) {
      formEl.setAttribute('data-styles-ready', 'true')
    }
}



const focusInOut = (event) => {
  // Change label color on focus/focusout
  document.body.addEventListener('focusin', (event) => {
    if (event.target.classList.contains("mktoField")) {
      event.target.classList.add("field-focus");
      event.target.parentNode.classList.add("field-focus");
    }
    if (event.target.classList.contains("mktoInvalid")) {
      event.target.parentNode.classList.add("field-invalid");
    }
    if (event.target.parentNode.querySelectorAll(".mktoError").length > 0) {
      event.target.parentNode.classList.add("field-invalid-error");
    }
  })

  document.body.addEventListener('focusout', (event) => {
    if (event.target.classList.contains("field-focus")) {
      event.target.classList.remove("field-focus");
      event.target.parentNode.classList.remove("field-focus");
    }
    if (event.target.value) {
      event.target.parentNode.classList.add("field-not-empty");
    } else {
      event.target.parentNode.classList.remove("field-not-empty");
    }
    if (event.target.classList.contains("mktoValid")) {
      event.target.parentNode.classList.remove("field-invalid");
    }
    if (event.target.parentNode.querySelectorAll(".mktoError").length > 0) {
      event.target.parentNode.classList.remove("field-invalid-error");
    }
  })
}



const init = () => {

  if (!MktoForms2) return

  inlineForms = [...document.querySelectorAll(".js-marketo-form")].filter(el => !el.classList.contains("js-initiatlized"))

  MktoForms2.whenRendered(form => {

    const formEl = form.getFormElem()[0];
    const random = `_${new Date().getTime()}_${Math.round(Math.random() * 200)}`;

    let inputmailEl = "";

    [...formEl.querySelectorAll("label[for]")].forEach(labelEl => {
      const inputEl = formEl.querySelector(`[id="${labelEl.htmlFor}"]`);
      if (labelEl.textContent.length > 40) {
        labelEl.style.textTransform = "none";
      }
      if (labelEl && inputEl) {
        labelEl.htmlFor = inputEl.id = inputEl.id + random;
  
        if (inputEl.getAttribute('type') == 'checkbox') {
          inputEl.nextSibling.setAttribute("for", inputEl.id);
          labelEl.classList.add("show-label");
          labelEl.parentNode.classList.add("checkboxed");
          inputEl.parentNode.classList.add("checkboxed");
        }
      }
    })

    destyleMktoForm(form);

  })

  MktoForms2.whenReady(form => {
    form.onSuccess(function (values, followUpUrl) {

      form.getFormElem().hide();

      if (document.getElementById('marketo-form-confirm-' + values.formid)) {
        document.getElementById('marketo-form-confirm-' + values.formid).style.display = 'block';
      }

      if (window.analytics) {
        window.analytics.track('Marketo form: ' + values.formid + ' (submitted)', { label: window.location.pathname.replace(/\//g, '') });
      }

      return false;

    });
    destyleMktoForm(form);
  });
  

  for (const form of inlineForms) {
    form.classList.add("js-initialized");
    focusInOut(event);
    initializeForm(form);
  }

}

export default {
  init
}
